












import { Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { replaceString } from '@/common/utils/dealWithString';

import GroupActivitySection from "@/components/groupType/index/GroupActivitySection.vue";

@Component({
  components: {
    "group-activity-section": GroupActivitySection,
  }
})
export default class GroupHeadReward extends Vue {
  @Getter("headReward")
  headReward!: string;

  replaceString: Function = replaceString;
}
